import { useState, useRef, useEffect } from 'react';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const SUGESTOES = [
  'Como calcular o custo total de uma importação RTS?',
  'Qual a diferença entre regime Simplificado e Normal?',
  'Como negociar MOQ menor com fornecedor chinês?',
  'Como classificar um produto no NCM?',
  'Quais documentos preciso para importar?',
  'Como calcular II e ICMS por dentro?',
];

export default function IA() {
  const { token } = useAuth();
  const [mensagens, setMensagens] = useState([
    { role: 'assistant', content: 'Olá! Sou a IA do Guilherme Bressan, treinada com todo o método de importação. Pode perguntar sobre NCM, custos, fornecedores, logística, desembaraço — qualquer coisa da sua operação!' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [mensagens]);

  const enviar = async (texto) => {
    const msg = texto || input.trim();
    if (!msg || loading) return;
    setInput('');

    const novaMensagem = { role: 'user', content: msg };
    setMensagens(prev => [...prev, novaMensagem]);
    setLoading(true);

    try {
      const historico = mensagens.map(m => ({ role: m.role, content: m.content }));
      const data = await api.post('/ia/chat', { mensagem: msg, historico }, token);
      setMensagens(prev => [...prev, { role: 'assistant', content: data.resposta }]);
    } catch (err) {
      setMensagens(prev => [...prev, { role: 'assistant', content: 'Erro ao processar sua pergunta. Tente novamente.' }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{display:'flex',flexDirection:'column',height:'calc(100vh - 0px)',padding:'28px 32px',gap:16}}>
      <div>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>IA do Guilherme</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Treinada com o método completo. Responde como ele responderia.</div>
      </div>

      {/* Chat */}
      <div style={{flex:1,background:'#fff',border:'0.5px solid #E4E6EF',borderRadius:14,display:'flex',flexDirection:'column',overflow:'hidden'}}>
        <div style={{flex:1,overflowY:'auto',padding:20,display:'flex',flexDirection:'column',gap:14}}>
          {mensagens.map((m, i) => (
            <div key={i} style={{display:'flex',justifyContent:m.role==='user'?'flex-end':'flex-start'}}>
              {m.role==='assistant' && (
                <div style={{width:30,height:30,borderRadius:8,background:'#1A2ECC',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'#fff',flexShrink:0,marginRight:10,marginTop:2}}>GB</div>
              )}
              <div style={{
                maxWidth:'75%',padding:'12px 16px',borderRadius:m.role==='user'?'14px 4px 14px 14px':'4px 14px 14px 14px',
                background:m.role==='user'?'#1A2ECC':'#F4F5F9',
                color:m.role==='user'?'#fff':'#0B0E1A',
                fontSize:13,lineHeight:1.6,whiteSpace:'pre-wrap'
              }}>
                {m.content}
              </div>
            </div>
          ))}
          {loading && (
            <div style={{display:'flex',alignItems:'center',gap:10}}>
              <div style={{width:30,height:30,borderRadius:8,background:'#1A2ECC',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'#fff',flexShrink:0}}>GB</div>
              <div style={{background:'#F4F5F9',padding:'12px 16px',borderRadius:'4px 14px 14px 14px',fontSize:13,color:'#6B7289'}}>
                <span style={{animation:'pulse 1s infinite'}}>Pensando...</span>
              </div>
            </div>
          )}
          <div ref={bottomRef} />
        </div>

        {/* Sugestões */}
        {mensagens.length <= 1 && (
          <div style={{padding:'0 20px 14px',display:'flex',flexWrap:'wrap',gap:8}}>
            {SUGESTOES.map(s => (
              <button key={s} onClick={()=>enviar(s)}
                style={{fontSize:11,padding:'6px 12px',background:'#F4F5F9',border:'0.5px solid #E4E6EF',borderRadius:99,cursor:'pointer',color:'#0B0E1A',whiteSpace:'nowrap'}}>
                {s}
              </button>
            ))}
          </div>
        )}

        {/* Input */}
        <div style={{padding:16,borderTop:'0.5px solid #E4E6EF',background:'#FAFBFE',display:'flex',gap:10}}>
          <input
            value={input}
            onChange={e=>setInput(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&!e.shiftKey&&(e.preventDefault(),enviar())}
            placeholder="Pergunte sobre NCM, custos, fornecedores, logística..."
            style={{flex:1,padding:'11px 14px',border:'0.5px solid #E4E6EF',borderRadius:10,fontSize:13,background:'#fff',outline:'none',fontFamily:'inherit'}}
            disabled={loading}
          />
          <button onClick={()=>enviar()} disabled={loading||!input.trim()} className="btn-primary" style={{padding:'11px 20px',fontSize:13}}>
            Enviar
          </button>
        </div>
      </div>
    </div>
  );
}
